
import React from 'react';
import { Box, Container } from '@chakra-ui/react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Image, Heading, Text } from '@chakra-ui/react';
import { Stack } from '@chakra-ui/react';


import img1 from '../assets/1.jpg';
import img2 from '../assets/2.jpg';
import img3 from '../assets/3.jpg';
import img4 from '../assets/4.jpg';
import img5 from '../assets/5.png';

const Hii = () => {
  return (
    <Container
    maxW={'container.xl'}
    minH={'100vh'}
  >
    <Heading
      borderBottom={'3px solid black'}
      textTransform={'uppercase'}
      py={'2'}
      w={'fit-content'}
      m={'auto'}
    >
      Services
    </Heading>
    <Stack
      p={'4'}
      direction={['column', 'row']}
    
      h={'full'}
      alignItems={'center'}
    >
      <Image
        src={img5}
        filter={'hue-rotate(-130deg)'}
        w={[`15rem`,`40%`]}
      ></Image>
      <Text p={["4","16"]} textAlign={"justify"} letterSpacing={"widest"} lineHeight={"190%"}>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Labore
        impedit modi facere? Id, rem totam eligendi perferendis expedita
        nesciunt aperiam enim, quaerat placeat beatae exercitationem eos ex
        sint iste error. Obcaecati reprehenderit animi laboriosam dolorum
        illo ratione excepturi, possimus illum laborum cupiditate libero!
        Tenetur nesciunt aut temporibus, dolores quis non dolorum incidunt
        sit. Labore culpa eligendi numquam quam placeat! Incidunt saepe
        impedit quod accusamus dignissimos! Aperiam reprehenderit quidem
        impedit. Sequi recusandae modi velit. Ad nesciunt et deserunt
        debitis modi? Optio quae iusto nam? Vero voluptatum voluptatem
      </Text>
    </Stack>
  </Container>
  )
}

export default Hii